(() => {
  const active = new Map();
  function start(region) {
    const template = document.getElementById('IBRSectionLoader');
    if (!region || !template) return () => {};
    let entry = active.get(region);
    if (!entry) {
      const overlay = template.content.firstElementChild.cloneNode(true);
      entry = { count: 0, overlay, busy: region.getAttribute('aria-busy') };
      active.set(region, entry);
      region.classList.add('ibr-section-loading');
      region.setAttribute('aria-busy', 'true');
      region.append(overlay);
    }
    entry.count++;
    let finished = false;
    return () => {
      if (finished) return;
      finished = true;
      if (--entry.count) return;
      entry.overlay.remove();
      region.classList.remove('ibr-section-loading');
      if (entry.busy === null) region.removeAttribute('aria-busy');
      else region.setAttribute('aria-busy', entry.busy);
      active.delete(region);
    };
  }
  window.IBRSectionLoading = { start };
})();
